<template lang="pug">
  app-dialog-confirm(v-model="$_show" @confirm="deleteSpecialization()")
    app-card-title.mt-5 Вы точно хотите удалить специализацию?
</template>

<script>
import { AppDialogToggable } from '@/components'
import { judgeService } from "@/_services";
import { mapState, mapMutations } from 'vuex'

export default {
  mixins: [AppDialogToggable],

  props: {
    specialisation: Object
  },

  computed: {
    ...mapState('judgeReestr', ['currentJudge'])
  },
  methods: {
    ...mapMutations('judgeReestr', ['setJudgeInJudges']),

    deleteSpecialization () {
      this.currentJudge.judgeSpecialisation = this.currentJudge.judgeSpecialisation.filter(item => item.id!=this.specialisation.id)
      if (this.updateJudge()) judgeService.deleteSpecialization(this.specialisation.id).then( data => console.log(data))
    },

    updateJudge () {
      this.currentJudge.signImage = ''
      judgeService.updateJudge(this.currentJudge).then(data => this.setJudgeInJudges(data))
      return true
    },
  }
}
</script>